//Import
import React, {useEffect, useReducer, useState} from "react";

//Layouts
import GroupHeader from "../../components/GroupHeader";
import GroupTableContainer from "../../components/GroupTableContainer";
import GroupItem from "../../components/GroupItem";
import GroupTableHeader from "../../components/GroupTableHeader";
import NavBar from "../../components/NavBar";

//vars
import ofc from "../../settings/variables";
import {abonosInitialState, abonosReducer,} from "../../reducers/abonosReducer";
import Mensaje from "../../components/Mensaje/Mensaje";
import {URL_BASE_API_V3} from "../../settings/urlBaseApi";
import {helpHttp} from "../../helpers/helpHtpp";
import {types} from "../../types/types";
import Loader from "../../components/Loader/Loader";

import Modal from "../../components/Modal";
import {message, Modal as ModalAnt} from "antd";
import {CheckCircleFilled, CloseCircleFilled} from "@ant-design/icons";
import {formatNumber} from "../../helpers/formatNumber";
import {formatDate, formatDateShort} from "../../helpers/formatDate";

// Componente base

const AbonosView = ({ ...rest }) => {
  const [permisosConcedidos, setPermisosConcedidos] = useState(false);
  const [state, dispatch] = useReducer(abonosReducer, abonosInitialState);
  const { db, metaRecaudo, totalAbonos } = state;
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [modalDetalleVisible, setModalDetalleVisible] = useState(false);
  const [dataModalDetalle, setDataModalDetalle] = useState("");
  const [dataModalDetalleAbonos, setDataModalDetalleAbonos] = useState("");
  const [dataModalDetalleCuotas, setDataModalDetalleCuotas] = useState("");

  const usarGpsAsesor = localStorage.getItem("usarGpsAsesor");

  // IDs de forma de pago que requieren detalle de cuotas (diario y semanal)
  const FORMA_PAGO_DIARIO_ID = 1;
  const FORMA_PAGO_SEMANAL_ID = 2;

  const handleClickRegistrarAbono = (e, el, cuota) => {
    const metodoPago = localStorage.getItem("metodoPago");

    e.preventDefault();

    let regexNumeroEntero = /^[0-9]\d*$/;

    if (!regexNumeroEntero.test(cuota.trim())) {
      message.error({
        content: `El valor del abono debe ser entero sin decimales`,
      });
    } else if (cuota > parseInt(el.saldo_pendiente)) {
      message.error({
        content: `El valor del abono supera el saldo del crédito`,
      });
    } else {

      // =========================
      // SOLO EFECTIVO
      // =========================
      if (metodoPago === "EFECTIVO") {

        ModalAnt.confirm({
          title: `${el.cliente.nombre_completo}`,
          content: (
              <div>
                <p>
                  Abono {formatNumber(cuota)}
                  <br />
                  Saldo Restante{" "}
                  {formatNumber(el.saldo_pendiente - cuota)}
                </p>
              </div>
          ),
          cancelText: "Cancelar",
          okText: "Registrar",
          onOk: () =>
              registrarAbono(cuota, el, "EFECTIVO"),
        });

      }

          // =========================
          // BANCO / EFECTIVO
      // =========================
      else if (metodoPago === "BANCO_EFECTIVO") {

        ModalAnt.confirm({
          title: `${el.cliente.nombre_completo}`,

          closable: true,

          okButtonProps: {
            style: { display: "none" },
          },

          cancelButtonProps: {
            style: { display: "none" },
          },

          content: (
              <div>
                <p>
                  Abono {formatNumber(cuota)}
                  <br />
                  Saldo Restante{" "}
                  {formatNumber(el.saldo_pendiente - cuota)}
                </p>

                <br />

                <p>Seleccione el método de pago</p>

                <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                      marginTop: "20px",
                    }}
                >
                  <button
                      className="ant-btn"
                      onClick={() => {
                        ModalAnt.destroyAll();

                        registrarAbono(
                            cuota,
                            el,
                            "EFECTIVO"
                        );
                      }}
                  >
                    EFECTIVO
                  </button>

                  <button
                      className="ant-btn ant-btn-primary"
                      onClick={() => {
                        ModalAnt.destroyAll();

                        registrarAbono(
                            cuota,
                            el,
                            "BANCO"
                        );
                      }}
                  >
                    BANCO
                  </button>
                </div>
              </div>
          ),
        });

      }
    }
  };

  const obtenerUbicacion = (timeout = 5000) => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        resolve({ latitud: 0, longitud: 0 });
        return;
      }

      const timer = setTimeout(() => {
        resolve({ latitud: 0, longitud: 0 });
      }, timeout);

      navigator.geolocation.getCurrentPosition(
          (position) => {
            clearTimeout(timer);
            resolve({
              latitud: position.coords.latitude,
              longitud: position.coords.longitude,
            });
          },
          () => {
            clearTimeout(timer);
            resolve({ latitud: 0, longitud: 0 });
          },
          {
            enableHighAccuracy: true,
            timeout,
            maximumAge: 0,
          }
      );
    });
  };

  const registrarAbono = async (cuota, el, metodoPago) => {
    let url = URL_BASE_API_V3 + "/abonos";
    setLoading(true);

    const usarGpsAsesor = localStorage.getItem("usarGpsAsesor");

    let ubicacion = {
      latitud: 0,
      longitud: 0,
    };

    if (usarGpsAsesor === "true") {
      ubicacion = await obtenerUbicacion(5000);
    }

    helpHttp()
        .post(url, {
          body: {
            creditoId: el.id,
            valor_abonado: cuota,
            metodoPago,
            latitud: ubicacion.latitud,
            longitud: ubicacion.longitud,
          },
        })
        .then((res) => {
          if (!res.err) {
            if (res instanceof TypeError) {
              ModalAnt.error({
                title: "Error",
                icon: <CloseCircleFilled style={{ color: "red" }} />,
                content: (
                    <div>
                      <p>
                        El abono al crédito del cliente $
                        {el.cliente.nombre_completo} por valor
                        {formatNumber(cuota)} no fue registrado, intentelo de nuevo!
                      </p>
                    </div>
                ),
                okText: "Cerrar",
              });
            } else {
              setError(null);

              dispatch({
                type: types.abonos_registrar_cuota,
                payload: {
                  id: el.id,
                  cuota: cuota,
                },
              });

              ModalAnt.confirm({
                title: `Abono Registrado`,
                icon: <CheckCircleFilled style={{ color: "green" }} />,
                content: (
                    <div>
                      <p>
                        El abono al crédito del cliente{" "}
                        {el.cliente.nombre_completo} por valor{" "}
                        {formatNumber(cuota)} fue registrado con éxito!
                      </p>
                    </div>
                ),
                cancelText: "Aceptar",
                okText: "Enviar a WhatsApp",
                onOk: () => {
                  let mensaje = `*Fecha*: ${formatDate(
                      res.abono.created_at
                  )}\n`;
                  mensaje += `*Transacción*: ${generarId(res.abono.id)}\n`;
                  mensaje += `*Cliente*: ${el.cliente.nombre_completo}\n`;
                  mensaje += `*Valor Abonado*: ${formatNumber(
                      res.abono.monto_total
                  )}\n`;
                  mensaje += `*Saldo*: ${formatNumber(
                      res.abono.saldo_pendiente
                  )}`;

                  const whatsappUrlSinNumero = `https://wa.me/?text=${encodeURIComponent(
                      mensaje
                  )}`;

                  window.open(whatsappUrlSinNumero, "_blank");
                },
              });
            }
          } else {
            ModalAnt.error({
              title: "Error",
              icon: <CloseCircleFilled style={{ color: "red" }} />,
              content: (
                  <div>
                    <p>
                      El abono al crédito del cliente $
                      {el.cliente.nombre_completo} por valor{" "}
                      {formatNumber(cuota)} no fue registrado, intentelo de nuevo!
                    </p>
                  </div>
              ),
              okText: "Cerrar",
            });

            setError(res);
          }

          setLoading(false);
        });
  };

  const generarId = (abonoId) => {
    const randomNumber = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
    const idWithRandom = `${abonoId}-${randomNumber}`;

    return btoa(idWithRandom);
  };

  const closeModalDetalle = () => {
    setModalDetalleVisible(false);
  };

  const handleClickDetalle = (el) => {
    const esDiarioOSemanal =
        el.forma_pago?.id === FORMA_PAGO_DIARIO_ID ||
        el.forma_pago?.id === FORMA_PAGO_SEMANAL_ID;

    cargarAbonosCredito(el.id);
    cargarCuotasCredito(el.id, esDiarioOSemanal);
    setDataModalDetalle(el);
    setModalDetalleVisible(true);
  };

  const cargarAbonosCredito = (creditoId) => {
    let urlAbonosCreditos =
        URL_BASE_API_V3 + "/creditos/" + creditoId + "/abonos";
    setLoading(true);

    helpHttp()
        .get(urlAbonosCreditos)
        .then((res) => {
          if (res !== undefined) {
            if (!res.err) {
              setError(null);
              setDataModalDetalleAbonos(res);
            } else {
              setError(res);
            }
          }
        });

    setLoading(false);
  };

  // Solo consulta el endpoint de cuotas cuando el crédito tiene
  // forma de pago diaria o semanal (ver handleClickDetalle)
  const cargarCuotasCredito = (creditoId, debeCargarCuotas) => {
    if (!debeCargarCuotas) {
      setDataModalDetalleCuotas("");
      return;
    }

    let urlCuotasCredito =
        URL_BASE_API_V3 + "/creditos/" + creditoId + "/cuotas";

    helpHttp()
        .get(urlCuotasCredito)
        .then((res) => {
          if (res !== undefined && !res.err) {
            setDataModalDetalleCuotas(res);
          }
        });
  };

  const filtroBusqueda = ({ target }) => {
    dispatch({
      type: types.abonos_buscar,
      payload: target.value,
    });
  };

  const limpiarFiltroBusqueda = () => {
    dispatch({
      type: types.abonos_limpiar_filtro,
    });
  };

  useEffect(() => {
    if (usarGpsAsesor === "true") {
      const obtenerUbicacion = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            setPermisosConcedidos(true);
          });
        } else {
          console.error();
        }
      };
      obtenerUbicacion();
    }
  }, [usarGpsAsesor]);

  const handleClickActualizarUbicacionCredito = (el) => {
    if (permisosConcedidos) {
      ModalAnt.confirm({
        title: `Actualizar Ubicación - ${el.cliente.nombre_completo}`,
        content: (
          <div>
            <p>
              ¿Está seguro de actualizar la ubicación del cliente{" "}
              {el.cliente.nombre_completo}?
            </p>
          </div>
        ),
        cancelText: "Cancelar",
        okText: "Actualizar",
        onOk: () => actualizarUbicacion(el),
      });
    } else {
      ModalAnt.warning({
        title: "Sin acceso al GPS",
        content:
          "No se concedieron permisos de ubicación. Contacte al administrador.",
        okText: "Aceptar",
      });
    }
  };

  const actualizarUbicacion = (el) => {
    setLoading(true);
    obtenerCoordenadas(el).then(() => {
      setLoading(false);
    });
  };

  const obtenerCoordenadas = (el) => {
    return new Promise(function (resolve) {
      navigator.geolocation.getCurrentPosition(
          function (position) {
            if (
                position.coords.latitude !== 0 &&
                position.coords.longitude !== 0
            ) {
              actualizarUbicacionCredito(
                  el,
                  position.coords.latitude,
                  position.coords.longitude
              );
            }
            resolve();
          },
          function (error) {
          },
          {
            enableHighAccuracy: true,
            timeout: 30000,
            maximumAge: 0,
          }
      );
    });
  };

  const handleClickIrUbicacion = (el) => {
    ModalAnt.confirm({
      title: `Ubicación - ${el.cliente.nombre_completo}`,
      content: (
        <div>
          <p>
            ¿Está seguro de ir a la ubicación del cliente{" "}
            {el.cliente.nombre_completo}?
          </p>
        </div>
      ),
      cancelText: "Cancelar",
      okText: "Ir Ubicación",
      onOk: () => {
        window.open(
          "https://maps.google.com/?q=" + el.latitud + "," + el.longitud
        );
      },
    });
  };

  const getEstadoFecha = (fecha) => {
    const MS_DIA = 1000 * 60 * 60 * 24;

    const fechaPago = new Date(fecha);
    const hoy = new Date();

    fechaPago.setHours(0, 0, 0, 0);
    hoy.setHours(0, 0, 0, 0);

    const diffDias = (fechaPago - hoy) / MS_DIA;

    return diffDias > 3
        ? "Activo"
        : diffDias > 0
            ? "Por vencer"
            : "Vencido";
  };

  const actualizarUbicacionCredito = (el, latitud, longitud) => {
    return new Promise(function (resolve) {
      let url = URL_BASE_API_V3 + "/creditos/ubicacion";
      helpHttp()
          .patch(url, {
            body: {
              latitud: latitud,
              longitud: longitud,
              creditoId: el.id,
            },
          })
          .then((res) => {
            if (!res.err) {
              setError(null);
              dispatch({
                type: types.abonos_actualizar_ubicacion,
                payload: res.credito,
              });
              message.success({
                content: `La ubicación del cliente ${el.cliente.nombre_completo} fue actualizada con éxito!`,
              });
            } else {
              setError(res);
            }
          });
      resolve();
    });
  };

  let url = URL_BASE_API_V3 + "/creditos/pendientes-abono";
  let urlMetaRecaudoTotalAbonos =
    URL_BASE_API_V3 + "/abonos/resumen-dia";
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);

        const [resMeta, resAbonos] = await Promise.all([
          helpHttp().get(urlMetaRecaudoTotalAbonos),
          helpHttp().get(url),
        ]);

        if (!isMounted) return;

        if (resMeta && !resMeta.err) {
          dispatch({
            type: types.abonos_meta_recaudo_total_abonos,
            payload: resMeta,
          });
        } else {
          setError(resMeta);
        }

        if (resAbonos && !resAbonos.err) {
          dispatch({
            type: types.abonos_todos,
            payload: resAbonos.creditos,
          });
        } else {
          setError(resAbonos);
        }
      } catch (err) {
        if (isMounted) setError(err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [url, urlMetaRecaudoTotalAbonos]);

  return (
    <div {...rest}>
      <GroupHeader
        category="Abonos"
        filtroBusqueda={filtroBusqueda}
        limpiarFiltroBusqueda={limpiarFiltroBusqueda}
      />
      <Modal
        type="bottom"
        show={modalDetalleVisible}
        opacity="0.8"
        w={"15em"}
        closeModalDetalle={closeModalDetalle}
        dataModalDetalle={dataModalDetalle}
        dataModalDetalleAbonos={dataModalDetalleAbonos}
        dataModalDetalleCuotas={dataModalDetalleCuotas}
      ></Modal>
      <GroupTableContainer>
        <GroupTableHeader section="Abonos" />

        {db !== null ? (
          db.map((el) => {
            let diasMoraDefault = localStorage.getItem("diasMoraDefault");
            let colorIcono = ofc.primary;
            if (el.monto_adelantado > 0) {
              colorIcono = ofc.violet;
            } else if (el.dias_atraso >= diasMoraDefault) {
              colorIcono = ofc.yellow;
            }

            return (
              <GroupItem
                inputvalue={el.saldo_pendiente < el.valor_cuota ? el.saldo_pendiente.toString() : el.valor_cuota.toString()}
                iconcolor={colorIcono}
                key={el.id}
                username={el.cliente.nombre_completo + " - " + getEstadoFecha(el.fecha_ultimo_pago_programado)}
                fechaCreacionCredito={el.created_at}
                fechaCuotaCredito={
                  <>
                    {formatDateShort(el.proxima_cuota_vence)} - <strong>{el.forma_pago.nombre}</strong>
                  </>
                }
                prestado={formatNumber(el.monto_principal)}
                montoAdelantado={el.monto_adelantado}
                montoVencido={el.monto_vencido}
                userdebt={formatNumber(el.saldo_pendiente)}
                handleClickRegistrarAbono={(e, cuota) =>
                  handleClickRegistrarAbono(e, el, cuota)
                }
                textoAbono="Abono"
                handleClickDetalle={(e) => handleClickDetalle(el)}
                mostrarSaldo={true}
                usarGpsAsesor={usarGpsAsesor}
                latitud={el.latitud}
                longitud={el.longitud}
                el={el}
                telefonoCliente={el.cliente.celular_1}
                handleClickActualizarUbicacionCredito={(e) =>
                  handleClickActualizarUbicacionCredito(el)
                }
                handleClickIrUbicacion={(e) => handleClickIrUbicacion(el)}
              />
            );
          })
        ) : (
          <Mensaje
            mensaje="No hay información para mostrar"
            type="info"
            title="Información"
          />
        )}
        {error && (
          <Mensaje
            mensaje={`Error ${error.status}: ${error.statusText}`}
            type="error"
            title="Error"
          />
        )}
      </GroupTableContainer>
      {loading && <Loader />}
      <NavBar
        view="abonos"
        texto1="Total Abonos"
        texto2="Meta de Recaudo"
        totalTexto2={formatNumber(metaRecaudo)}
        totalTexto1={formatNumber(totalAbonos)}
        progreso={parseInt((totalAbonos * 100) / metaRecaudo)}
      />
    </div>
  );
};

export default AbonosView;
